// @flow

export const emailRegex = /^(.+)@(.+)$/;
